import React, { useState, useEffect } from 'react';
import { Modal, Paper, Typography } from '@material-ui/core';
import Button from 'components/Button';
import { LoadingComponent } from 'components/Loading';
import { fretesAPI } from 'services/apiRest';
import { Container, WrapperInput, WrapperButtons } from './styles';

export default function ModalGerarViagens({ open, onClose, onConfirm, frete }) {
  const [loading, setLoading] = useState(false);
  const [xmls, setXmls] = useState([]);
  const [carregandoXmls, setCarregandoXmls] = useState(true);

  useEffect(() => {
    if (open && frete) {
      carregarXmls();
    } else {
      setXmls([]);
    }
  }, [open, frete]);

  const carregarXmls = async () => {
    if (!frete) return;
    try {
      setCarregandoXmls(true);
      const xmlsList = await fretesAPI.listarXmls(frete.id);
      setXmls(Array.isArray(xmlsList) ? xmlsList : []);
    } catch (e) {
      console.error('[ModalGerarViagens] Erro ao carregar XMLs:', e);
      setXmls([]);
    } finally {
      setCarregandoXmls(false);
    }
  };

  const handleConfirm = async () => {
    if (!frete) return;
    setLoading(true);
    try {
      await onConfirm();
    } catch (e) {
      // Erro já tratado no componente pai
    } finally {
      setLoading(false);
    }
  };

  if (!frete) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        style={{
          padding: '30px',
          minWidth: '500px',
          maxWidth: '600px',
          outline: 'none',
        }}
      >
        <Container>
          <Typography variant="h6" style={{ marginBottom: '20px', fontWeight: 'bold' }}>
            Gerar Viagens do Frete
          </Typography>

          <div style={{ marginBottom: '20px' }}>
            <Typography variant="body1" style={{ marginBottom: '10px' }}>
              <strong>Frete:</strong> {frete.numero ? `FRETE Nº ${frete.numero}` : frete.id}
            </Typography>
            <Typography variant="body2" style={{ color: '#666', marginBottom: '15px' }}>
              Será criada uma viagem para cada XML anexado ao frete.
            </Typography>

            {carregandoXmls ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <LoadingComponent width="150px" height="150px" />
              </div>
            ) : xmls.length === 0 ? (
              <Typography variant="body2" style={{ color: '#f44336', fontWeight: 'bold' }}>
                ⚠️ Este frete não possui XMLs anexados. Anexe pelo menos um XML antes de gerar viagens.
              </Typography>
            ) : (
              <div>
                <Typography variant="body2" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  XMLs encontrados ({xmls.length}):
                </Typography>
                <div style={{ 
                  maxHeight: '200px', 
                  overflowY: 'auto', 
                  border: '1px solid #ddd', 
                  borderRadius: '4px',
                  padding: '10px',
                  backgroundColor: '#f9f9f9'
                }}>
                  {xmls.map((xml, index) => (
                    <div key={xml.id} style={{ 
                      padding: '8px', 
                      marginBottom: '5px',
                      backgroundColor: 'white',
                      borderRadius: '4px',
                      border: '1px solid #eee'
                    }}>
                      <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                        {index + 1}. {xml.xml_filename}
                      </Typography>
                      {xml.xml_chave && (
                        <Typography variant="caption" style={{ color: '#666', display: 'block' }}>
                          Chave: {xml.xml_chave}
                        </Typography>
                      )}
                      {xml.xml_tipo && (
                        <Typography variant="caption" style={{ color: '#666', display: 'block' }}>
                          Tipo: {xml.xml_tipo}
                        </Typography>
                      )}
                    </div>
                  ))}
                </div>
                <Typography variant="body2" style={{ marginTop: '10px', color: '#2196f3', fontWeight: 'bold' }}>
                  ✅ {xmls.length} viagem(ns) será(ão) criada(s)
                </Typography>
              </div>
            )}
          </div>

          <WrapperButtons>
            <Button
              label="Cancelar"
              type="button"
              onClick={onClose}
              disabled={loading}
            />
            <Button
              label={loading ? 'Gerando...' : 'Confirmar'}
              type="button"
              onClick={handleConfirm}
              disabled={loading || xmls.length === 0}
              primary
            />
          </WrapperButtons>
        </Container>
      </Paper>
    </Modal>
  );
}

